'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroSearchBar = require('./NitroSearchBar');

var _NitroSearchBar2 = _interopRequireDefault(_NitroSearchBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroSearchBar2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-search-bar/index.js
// module id = 160
// module chunks = 4